import MeetingMessageActionEntrySource from '../store/schema/MeetingMessageActionEntrySource';
import { getStore } from '../store/store';
import { ObservableMap } from 'mobx';

export function markSessionStart(itemId: string, entrySource: MeetingMessageActionEntrySource) {
    const key = getMeetingMessageKey(itemId, entrySource);
    const keyToSessionStartMap = getSessionStartMap();
    keyToSessionStartMap[key] = Date.now();
}

export function getSessionDuration(
    itemId: string,
    entrySource: MeetingMessageActionEntrySource
): number {
    const key = getMeetingMessageKey(itemId, entrySource);
    const keyToSessionStartMap = getSessionStartMap();

    if (!keyToSessionStartMap[key]) {
        // Return 0 if start timestamp is not present, as some scenarios don't need to track session in time
        return 0;
    }

    return Date.now() - keyToSessionStartMap[key];
}

export function markSessionEnd(
    itemId: string,
    entrySource: MeetingMessageActionEntrySource
): number {
    const key = getMeetingMessageKey(itemId, entrySource);
    const keyToSessionStartMap = getSessionStartMap();

    if (!keyToSessionStartMap[key]) {
        // Return 0 if start timestamp is not present, as some scenarios don't need to track session in time
        return 0;
    }

    const duration = Date.now() - keyToSessionStartMap[key];

    // Remove the entry as we've consumed it
    delete keyToSessionStartMap[key];

    return duration;
}

function getSessionStartMap(): ObservableMap<string, number> {
    return getStore().metrics.keyToSessionStartMap;
}

function getMeetingMessageKey(
    itemId: string,
    entrySource: MeetingMessageActionEntrySource
): string {
    return entrySource + itemId;
}
